import type { ExportType } from '@/apis/opsTypes'

export interface ExportForm {
    name: string
    type: ExportType
    format: 'ndjson.gz' | 'parquet'
    schedule: 'hourly' | 'daily'
    start_date: string
    sub_tenant: string
    endpoint: string
    region: string
    bucket: string
    prefix: string
    access_key_id: string
    secret_access_key: string
    project_id: string
    dataset: string
    table: string
    location: string
    service_account_json: string
}

export const EMPTY_EXPORT_FORM: ExportForm = {
    name: '',
    type: 's3',
    format: 'parquet',
    schedule: 'hourly',
    start_date: '',
    sub_tenant: '',
    endpoint: '',
    region: 'auto',
    bucket: '',
    prefix: 'yom/events/',
    access_key_id: '',
    secret_access_key: '',
    project_id: '',
    dataset: '',
    table: 'yom_events',
    location: 'US',
    service_account_json: '',
}

/** The POST /exports body for a form; throws a readable error for an unparseable key file. */
export function exportBody(f: ExportForm): Record<string, unknown> {
    const common: Record<string, unknown> = {
        name: f.name.trim() || `${f.type} export`,
        type: f.type,
        schedule: f.schedule,
        sub_tenant: f.sub_tenant.trim() || null,
        ...(f.start_date ? { start_date: f.start_date } : {}),
    }
    if (f.type === 's3') {
        return {
            ...common,
            format: f.format,
            s3: {
                endpoint: f.endpoint.trim(),
                region: f.region.trim() || 'auto',
                bucket: f.bucket.trim(),
                prefix: f.prefix.trim(),
                access_key_id: f.access_key_id.trim(),
                secret_access_key: f.secret_access_key,
            },
        }
    }
    let sa: unknown
    try {
        sa = JSON.parse(f.service_account_json)
    } catch {
        throw new Error('The service account key must be the JSON key file')
    }
    return {
        ...common,
        bigquery: {
            project_id: f.project_id.trim(),
            dataset: f.dataset.trim(),
            table: f.table.trim(),
            location: f.location.trim(),
            service_account_json: sa,
        },
    }
}
